import { v4 as uuidv4 } from "uuid";
export class UserLoginModel {
    constructor() {
        this.id = uuidv4();
        this.employeeId = uuidv4();
        this.tenantId = "";
        this.ipAddress = "";
        this.timestamp = new Date();
        this.dateTimeStampFormatted = "";
        this.browser = "";
    }
}
export default class UserLogin extends UserLoginModel {
    constructor(model) {
        super();
        Object.assign(this, model);
    }
}
